import gql from "graphql-tag";

export default gql`

fragment GoogleConfigFragment on GoogleConfig {
  placeId
}

`